import clsx from "clsx";

// Interfaces
import { IApprovedMessage } from "./interfaces";

// MUI
import { Stack, SvgIcon, Typography } from "@mui/material";

// Icons
import { ReactComponent as CheckIcon } from "@/Washouts/assets/icons/Check.svg";
import { ReactComponent as ProgressIcon } from "@/Washouts/assets/icons/Progress.svg";

const isPending = (status: string): boolean => ["PENDING", "IN_PROGRESS", "RETRACTED"].includes(status);

const getStatusIcons = (status: string) => {
	if (!status) {
		return null;
	}

	switch (status) {
		case "APPROVED":
			return <SvgIcon className="!text-[18px]" component={CheckIcon} inheritViewBox />;
		case "PENDING":
		case "IN_PROGRESS":
		case "RETRACTED":
			return <SvgIcon className="!text-[18px] !mb-[2px]" component={ProgressIcon} inheritViewBox />;
		default:
			break;
	}

	return null;
};

export default function ApprovedMessage(props: Readonly<IApprovedMessage>) {
	const {
		title = "",
		titleClassName = "",
		status = "",
		className = "",
		textStyle = null,
		alignItems = "center",
		visibility = false,
	} = props;

	const isPendingStatus = isPending(status);
	const titleToShow = isPendingStatus ? "Washout is currently in review ..." : title;

	return (
		<Stack
			direction="row"
			justifyContent="flex-start"
			alignItems={alignItems}
			className={className}
			spacing={1}
			sx={{ visibility: visibility ? "visible" : "hidden" }}
		>
			{getStatusIcons(status)}
			<Typography
				variant="caption"
				display="inline-block"
				sx={textStyle}
				className={clsx({
					"!font-montserrat !text-[16px]": true,
					"!text-success": status === "APPROVED",
					"!text-default": isPendingStatus,
					[titleClassName]: Boolean(titleClassName),
				})}
			>
				{titleToShow}
			</Typography>
		</Stack>
	);
}
